import { render, staticRenderFns } from "./Diy.vue?vue&type=template&id=2d0a6baa&scoped=true&"
import script from "./Diy.vue?vue&type=script&lang=js&"
export * from "./Diy.vue?vue&type=script&lang=js&"
import style0 from "./Diy.vue?vue&type=style&index=0&id=2d0a6baa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a6baa",
  null
  
)

export default component.exports